/* eslint-disable max-lines, functional/no-return-void, functional/no-this-expressions, functional/immutable-data, unicorn/filename-case */
import { defineStore } from "pinia";
import { productFruits } from "product-fruits";

import { ILoggedInUser } from "@/interfaces/AuthInterfaces";
import { getCurrentUser } from "@/Services/AuthService";
import { PERMISSION_TYPE } from "@/Constants/Permissions";
import { ProductFruitsUserObject } from "@/interfaces/ProductFruits";

interface IAuthStoreState {
  loggedInUser: ILoggedInUser;
  isImpersonating: boolean;
}

const setProductFruitsUser = (user: ProductFruitsUserObject) => {
  console.log("Identify ProductFruits User as", user);
  return productFruits.safeExec(() => window?.productFruits?.identifyUser({ ...user, signUpAt: new Date().toISOString() }))
};

export const useAuthStore = defineStore({
  id: "AuthStore",
  state: (): IAuthStoreState => ({
    loggedInUser: {
      email: "",
      id: "",
      phoneNumber: "",
      profilePicture: "",
      firstName: "",
      lastName: "",
      permissions: [],
      points: 0,
    } as ILoggedInUser,
    isImpersonating: false,
  }),
  getters: {
    isAuthorised(state) {
      return !!state.loggedInUser.id;
    },
    getCurrentUser(state) {
      const { id, firstName, lastName, email, phoneNumber, profilePicture, points } = state.loggedInUser;
      return {
        id,
        firstName,
        lastName,
        email,
        phoneNumber,
        profilePicture,
        points,
      };
    },
    getUserPermissions(state) {
      return state.loggedInUser.permissions;
    },
    getCurrentUserRole(state) {
      return state.loggedInUser.permissions.includes(PERMISSION_TYPE.STORE_FEATURE_FLAG) ? "super-admin" : "";
    },
    isImpersonatingUser(state) {
      return state.isImpersonating;
    }
  },
  actions: {
    async fetchCurrentUser() {
      try {
        const userData = await getCurrentUser();
        if (userData?.me?.id) {
          const { email, id, phoneNumber, profilePicture, firstName, lastName, permissions } = userData.me;
          this.loggedInUser = {
            email,
            id,
            phoneNumber,
            profilePicture,
            firstName,
            lastName,
            permissions,
            points: 0,
          };
          this.isImpersonating = false;
          const userRole = this.getCurrentUserRole;
          localStorage.setItem("userRole", userRole);

          setProductFruitsUser({
            username: id ?? "",
            email: email ?? "",
            firstname: firstName ?? "",
            lastname: lastName ?? "",
            role: userRole || "user"
          });
        }
      } catch (e: any) {
        console.log("Authentication Failed", e);
      }
    },
    setCurrentUserPoints(points: number) {
      this.loggedInUser.points = points;
    },
    setLoggedInUser(payload: ILoggedInUser) {
      const { email, id, phoneNumber, profilePicture, firstName, lastName, permissions } = payload;
      this.loggedInUser = {
        email,
        id,
        phoneNumber,
        profilePicture,
        firstName,
        lastName,
        permissions,
        points: 0,
      };
      this.isImpersonating = true;
      setProductFruitsUser({
        username: id ?? "",
        email: email ?? "",
        firstname: firstName ?? "",
        lastname: lastName ?? "",
        role: this.getCurrentUserRole || "user"
      });
    },
    stopImpersonating() {
      this.isImpersonating = false;
      this.fetchCurrentUser();
    }
  },
  persist: true,
});
